<template>
  <v-card :color="box.order_id ? 'white':'grey lighten-3'" height="100%" :loading="loading" :disabled="loading">
    <v-toolbar>
        <v-toolbar-title>
            <v-icon left>{{ box.order_id ? 'mdi-package-variant-closed' : 'mdi-package-variant'}}</v-icon>
            {{box.name}}
        </v-toolbar-title>
        <v-spacer />
            <b class="bold">{{box.order_id ? box.client.displayName : ''}}</b>
        <v-spacer />
        <v-toolbar-items class="hidden-sm-and-down">
            <DetailPendingBox v-model="box" @refresh="refresh" />
        </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
        <v-alert v-if="error" dense outlined text type="error" dismissible>{{ error }}</v-alert>
        <template v-if="box.order_id">
            <v-row>
                <v-col cols="6">
                    Order Id : #{{box.order_id}}
                    <v-btn icon x-small class="ml-4" :href="'/build/build/' + box.order_id">
                        <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-chip :color="box.build.status_id=='backordered'?'red':'green'" dark small>{{box.build.status_id}}</v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols=12>
                    Client : {{box.client.displayName}}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex align-center">
                    Missing products :
                    <template v-if="box.missingItems.length">
                    {{box.missingItems.length}} Products missing
                    <v-btn text @click="missingItemsDetail = !missingItemsDetail">Detail</v-btn>
                    </template>
                    <template v-else>
                    All products are picked
                    </template>
                </v-col>
            </v-row>
            <v-row v-if="missingItemsDetail">
                <v-col>
                    <v-simple-table>
                    <template #default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Product Name
                                </th>
                                <th class="text-left">
                                    Needed Qty
                                </th>
                                <th class="text-left">
                                    On hand
                                </th>
                                <th>
                                    Received at
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="item in box.missingItems"
                            :key="'_missing_'+item.id"
                            >
                                <td>{{ item.name }}</td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ item.on_hand }}</td>
                                <td>{{ item.expectedRefillDate }}</td>
                            </tr>
                        </tbody>
                    </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            Empty
        </template>
    </v-card-text>
    <v-card-actions>
        <v-btn color="orange" v-if="canPickedSomeProducts" @click="createPickwave">Create a pickwave</v-btn>
        <v-spacer></v-spacer>
        <!-- AssignToCart
            v-if="canStartBuild"
            v-model="box"
            :label="box.missingItems.length ? 'Start Partial Build':'Start Build'"
            @refresh="refresh"
        / -->
        <v-btn
            v-if="canStartBuild"
            @click="startBuild"
        >
            {{ box.missingItems.length ? 'Start Partial Build':'Start Build' }}
        </v-btn>
        <v-btn color="primary" v-if="box.build && box.build.currentHandling" :to="'/build/handling/'+box.build.currentHandling.id">
            Continue building
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import NewApiService from "@/utils/new.api.service";
import { mapActions } from 'vuex'
import DetailPendingBox from './DetailPendingBox.vue'
export default {
    components: {
        DetailPendingBox
    },
    props:{
        value:{
            type:Object,
            required:true
        }
    },
    data: () => ({
        missingItemsDetail:false,
        loading: false,
        error: null
    }),
    computed:{
        box:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input',val)
            }
        },
        withProductPicked(){
            return this.box.items.length
        },
        canPickedSomeProducts(){
            return this.box.missingItems.filter(item => item.on_hand > 0).length
        },
        needPo(){
            const alreadyOpenPo = this.box.pos.filter(po => po.poStatus == 'draft' || po.poStatus == 'validated').length;
            return this.box.missingItems.filter(item => item.on_hand < item.quantity).length && alreadyOpenPo == 0
        },
        haveMissingItems(){
            return this.box.missingItems.length
        },
        canStartBuild(){
            return this.box.build && this.box.build.status_id != 'handling' && this.box.items.length
        }
    },
    methods:{
        ...mapActions("pickwave",["createAndStartPickWave"]),
        ...mapActions("purchaseOrders", ["createFromOrder"]),
        ...mapActions("pendingbox", {getPendingBox : "get"}),
        refresh(){
            this.getPendingBox(this.box.id)
            .then(({pendingBox}) => {
                this.box = pendingBox
            })
        },
        createPickwave(){ 
            this.createAndStartPickWave([this.box.order_id])
            .then(({pickwave}) => {
              this.$router.push({name:"Pick Wave Detail", params:{id:pickwave.id}})
            })
        },
        // Le bouton qui appelait cette méthode a été retiré (commit 4c0c28d) ;
        // la méthode est conservée au cas où il reviendrait.
        //
        // /!\ `po` PEUT ÊTRE NULL DEPUIS LE LOT « tableau d'arrivée ». L'ancien
        // backend créait toujours un PO, fût-il vide, et `po.id` était donc
        // toujours lisible. Le nouveau rend `po: null` quand il n'y avait rien à
        // commander (tout était déjà couvert) ou quand aucun fournisseur n'a pu
        // être résolu : naviguer vers `po.id` planterait. On ne redirige que
        // s'il y a quelque part où aller, et on dit pourquoi sinon.
        createPo(){
            this.loading = true
            this.error = null
            this.createFromOrder(this.box.order_id)
            .then(({po, unresolved}) => {
                if (po && po.id) {
                    this.$router.push({name:"Purchase Orders Detail", params:{id:po.id}})
                    return
                }

                if (unresolved && unresolved.length) {
                    const names = unresolved.map(item => item.name || ('#' + item.productId)).join(', ')
                    this.error = "Aucun fournisseur n'est rattaché à ces produits : " + names
                    return
                }

                this.error = "Rien à commander : tout est déjà réservé sur une commande fournisseur."
                this.refresh()
            })
            .catch((response) => {
                this.error = response && response.data ? response.data.message : "Approvisionnement impossible"
            })
            .finally(() => {
                this.loading = false
            })
        },
        startBuild () {
            this.loading=true
            this.error = null
            NewApiService.put(`admin/build/${this.box.build.id}/assign-to-cart`)
                .then(({ data }) => {
                    this.$router.push({path:'/build/handling/'+data.handling.id})
                })
                .catch(({ response }) => {
                    this.error = response.data.message
                }).
                finally(() => {
                    this.loading=false
                })
        }
    }
}
</script>

<style>

</style>